import React from "react";
import Checkbox from '@mui/material/Checkbox';

export default function CustomCheckBox(props) {
    if (props.label) {
        return (<table
            className={props.className ? props.className + " horizontalScreen" : "smallTextBold horizontalScreen"}>
            <tbody>
            <tr>
                <td>
                    <Checkbox sx={{
                        color: props.checkboxcolor ? props.checkboxcolor : "var(--blue_3)",
                        '&.Mui-checked': {
                            color: props.checkboxcolor ? props.checkboxcolor : "var(--blue_3)",
                        },
                    }} {...props} />
                </td>
                <td>
                    <label>{props.label}</label>
                </td>
            </tr>
            </tbody>
        </table>)
    } else {
        return (
            <Checkbox sx={{
                color: props.checkboxcolor ? props.checkboxcolor : "var(--blue_3)",
                '&.Mui-checked': {
                    color: props.checkboxcolor ? props.checkboxcolor : "var(--blue_3)",
                },
            }} {...props} />
        )
    }
}